import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"
import "tippy.js/dist/tippy.css"

export default class extends Controller {
  static values = {
    tooltipPlacement: { type: String, default: "auto" }
  }

  connect() {
    const elements = this.element.querySelectorAll('[data-toggle="tooltip"]')

    elements.forEach((el) => {
      tippy(el, {
        content(reference) {
          return reference.getAttribute('data-title')
        }
      })
    })
  }
}
